import { type ContentIndexedAction, contentIndexed } from 'app/content/actions';
import { search } from 'app/content-search/actions';
import type { SagaIterator } from 'redux-saga';
import { all, put, takeLatest } from 'redux-saga/effects';
import { SHAPE_ID } from '../assets/constants';
import { SEARCH_NAME } from './constants';

export function* searchAssets({ payload }: ContentIndexedAction): SagaIterator {
  if (payload.shapeId === 'ASSET') {
    yield put(search.requested({ searchName: SEARCH_NAME })({ shapeIds: [SHAPE_ID] }));
  }
}

export default function* root(): SagaIterator {
  yield all([takeLatest(contentIndexed, searchAssets)]);
}
